import React, { useEffect, useMemo, useState } from "react";
import { Wrapper } from "../HOC";
import { VaultDocument} from "../components";
import { FaCloudUploadAlt } from "react-icons/fa";
import { Line } from "rc-progress";
import { useVault } from "../context/VaultContext";
import useUploadDocument from "../hooks/useUploadDoc";
import LoadingModal from "../components/Loader/LoadingModal";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../redux/modal/modalRedux";
import EmptyContent from "../components/Popups/EmptyContent";
import { auth } from "../firebase/firebase";

const Vault = () => {
  const [vault, setVault] = useState("insuranceDocuments");
  const { onChange, doc, setUrl } = useUploadDocument();
  const { uploaddocuments, loading, setLoading, done, setDone, files, getfiles, total } = useVault();
  const dispatch = useDispatch();

  const percentageUsed = useMemo(() => {
    return Math.round((total / 52428800) * 100);
  }, [total]);

  useEffect(() => {
    if (doc.url && !done) {
      uploaddocuments({
        documentName: doc.file.name,
        documentType: vault,
        downloadUrl: doc.url,
        fileSize: doc.file.size,
      });
    }
  }, [doc, done, uploaddocuments, vault]);

  useEffect(() => {
    if (auth.currentUser) {
      getfiles(vault);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vault]);

  useEffect(() => {
    if (loading) {
      dispatch(openModal());
    } else if (done) {
      setDone(false);
      setUrl(null);
      dispatch(closeModal());
    } else {
      dispatch(closeModal());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Wrapper>
      <>
        <LoadingModal />
        <div className="w-[18%]">
          <p className="text-2xl font-bold pb-5">My Vault</p>
          <p
            className={`text-sm font-medim border py-3 px-5 text-center rounded-xl text-primary mb-2 cursor-pointer hover:bg-primary hover:text-white ${
              vault === "insuranceDocuments" && "bg-primary text-[#fff]"
            }`}
            onClick={async () => {
              setVault("insuranceDocuments");
              await getfiles("insuranceDocuments");
            }}
          >
            Insurance Policies
          </p>
          <p
            className={`text-sm font-medim border py-3 px-5 text-center rounded-xl text-primary mb-2 cursor-pointer hover:bg-primary hover:text-white ${
              vault === "projectDocuments" && "bg-primary text-[#fff]"
            }`}
            onClick={async () => {
              setVault("projectDocuments");
              await getfiles("projectDocuments");
            }}
          >
            Projects Documents
          </p>
          <p
            className={`text-sm font-medim border py-3 px-5 text-center rounded-xl text-primary mb-2 cursor-pointer hover:bg-primary hover:text-white ${
              vault === "claimDocuments" && "bg-primary text-[#fff]"
            }`}
            onClick={async () => {
              setVault("claimDocuments");
              await getfiles("claimDocuments");
            }}
          >
            Claim Files
          </p>
        </div>

        <div className="w-[45%] mb-20">
          <div className="flex items-center pb-3">
            <label htmlFor="imageUpload">
              <div className="flex items-center justify-center border-2 border-primary py-2 px-5 rounded-xl cursor-pointer">
                <FaCloudUploadAlt className="text-xl text-primary" />
                <p className="text-sm text-primary pl-3">Upload</p>
              </div>
            </label>
            <input
              id="imageUpload"
              type="file"
              accept={`${vault === "claimDocuments" && "application/*"}`}
              className="w-0.1 h-0.1 overflow-hidden hidden"
              onChange={(e) => {
                onChange(e, vault, setLoading);
              }}
            />
          </div>
          <p className="font-semibold text-lg pb-2">
            {vault === "claimDocuments" ? "Claims Files" : vault === "projectDocuments" ? "My Projects Documents" : "My Insurance Policies Documents"}
          </p>
          {vault === "claimDocuments" ? (
            <div>{files?.length > 0 ? files?.map((item) => <VaultDocument key={item.id} item={item} />) : <EmptyContent />}</div>

            // <VaultClaim contents={files} />
          ) : vault === "insuranceDocuments" ? (
            <div>{files?.length > 0 ? files?.map((item) => <VaultDocument key={item.id} item={item} />) : <EmptyContent />}</div>
          ) : (
            <div>{files?.length > 0 ? files?.map((item) => <VaultDocument key={item.id} item={item} />) : <EmptyContent />}</div>
          )}
        </div>
        

        <div className="w-[30%] border-2 rounded-xl py-2 px-5">
          <p className="font-semibold py-3">Documents Storage</p>
          <Line percent={percentageUsed} strokeWidth={4} trailWidth={4} strokeColor="#0086E6" />
          <div className="flex justify-between items-center pt-1">
            <p></p>
            <p className="text-xs text-primary">{percentageUsed}%</p>
            <p className="text-xs">100%</p>
          </div>
        </div>
      </>
    </Wrapper>
  );
};

export default Vault;
